import { __read, __values } from "tslib";
import moment from "moment";
import { useOutsideClick } from "../_util/use-outside-click";
export function getNow(value) {
    // eslint-disable-next-line dot-notation
    return value["tz"] && value["tz"]()
        ? // eslint-disable-next-line dot-notation
            moment()["tz"](value["tz"]())
        : moment();
}
export function getYearMonthDate(date) {
    return {
        year: date.year(),
        month: date.month(),
        date: date.date(),
    };
}
var granularityList = [
    "year",
    "quarter",
    "month",
    // "week",
    "date",
    "hour",
    "minute",
    "second",
];
// moment("2021-03-25 08:00:00").tz("Pacific/Niue").isSame(moment("2021-03-25 08:00:00")) // true
//
// isSame(moment("2021-03-25 08:00:00").tz("Pacific/Niue"), moment("2021-03-24 13:00:00")) // true
export function isSame(a, b, granularity) {
    var e_1, _a;
    if (granularity === void 0) { granularity = "second"; }
    if (!moment.isMoment(a) || !moment.isMoment(b)) {
        return false;
    }
    if (granularity === "day") {
        // eslint-disable-next-line no-param-reassign
        granularity = "date";
    }
    var result = true;
    try {
        for (var granularityList_1 = __values(granularityList), granularityList_1_1 = granularityList_1.next(); !granularityList_1_1.done; granularityList_1_1 = granularityList_1.next()) {
            var g = granularityList_1_1.value;
            result = result && a[g]() === b[g]();
            if (granularity === g) {
                return result;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (granularityList_1_1 && !granularityList_1_1.done && (_a = granularityList_1.return)) _a.call(granularityList_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return result;
}
export function isBefore(a, b, granularity) {
    var e_2, _a;
    if (granularity === void 0) { granularity = "second"; }
    if (!moment.isMoment(a) || !moment.isMoment(b)) {
        return false;
    }
    if (granularity === "day") {
        // eslint-disable-next-line no-param-reassign
        granularity = "date";
    }
    try {
        for (var granularityList_2 = __values(granularityList), granularityList_2_1 = granularityList_2.next(); !granularityList_2_1.done; granularityList_2_1 = granularityList_2.next()) {
            var g = granularityList_2_1.value;
            if (a[g]() < b[g]()) {
                return true;
            }
            if (a[g]() > b[g]()) {
                return false;
            }
            if (granularity === g) {
                return false;
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (granularityList_2_1 && !granularityList_2_1.done && (_a = granularityList_2.return)) _a.call(granularityList_2);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return false;
}
export function isAfter(a, b, granularity) {
    if (granularity === void 0) { granularity = "second"; }
    return isBefore(b, a, granularity);
}
/**
 * 选择器弹出 Trigger
 */
export var DatePickerTrigger = function (_a) {
    var childrenElementRef = _a.childrenElementRef, overlayElementRef = _a.overlayElementRef, visible = _a.visible, render = _a.render, onOpen = _a.onOpen, onClose = _a.onClose;
    var listen = useOutsideClick([childrenElementRef, overlayElementRef]).listen;
    listen(function () {
        if (visible) {
            onClose();
        }
    });
    return render({
        overlayProps: {},
        childrenProps: {
            onClick: function (event) {
                event.stopPropagation();
                if (!visible) {
                    onOpen();
                }
                else {
                    onClose();
                }
            },
        },
    });
};
/**
 * 当前时间是否为可选
 */
export function isValidDate(date, _a, startValue) {
    var range = _a.range, _b = _a.disabledDate, disabledDate = _b === void 0 ? function () { return true; } : _b;
    var _c = __read(range || [null, null], 2), rangeMin = _c[0], rangeMax = _c[1];
    if (moment.isMoment(rangeMin) && isAfter(rangeMin, date, "day")) {
        return false;
    }
    if (moment.isMoment(rangeMax) && isBefore(rangeMax, date, "day")) {
        return false;
    }
    return disabledDate(date, startValue);
}
export function isValidMonth(date, _a) {
    var range = _a.range, _b = _a.disabledMonth, disabledMonth = _b === void 0 ? function () { return true; } : _b;
    var _c = __read(range || [null, null], 2), rangeMin = _c[0], rangeMax = _c[1];
    if (moment.isMoment(rangeMin) && isAfter(rangeMin, date, "month")) {
        return false;
    }
    if (moment.isMoment(rangeMax) && isBefore(rangeMax, date, "month")) {
        return false;
    }
    return disabledMonth(date);
}
//# sourceMappingURL=util.js.map